import { LanguageService } from '@bigcommerce/checkout-sdk';
import { object, string, ObjectSchema, StringSchema } from 'yup';

import { getTermsConditionsValidationSchema } from '../termsConditions';

import { PaymentFormValues } from './PaymentForm';

import { getFormFieldsValidationSchema } from '../formFields'

import B3Checkout from '../b3checkout'

export interface PaymentValidationSchemaOptions {
    additionalValidation?: ObjectSchema<Partial<PaymentFormValues>>;
    isTermsConditionsRequired: boolean;
    language: LanguageService;
}

export default function getPaymentValidationSchema({
    additionalValidation,
    isTermsConditionsRequired,
    language,
}: PaymentValidationSchemaOptions): ObjectSchema<PaymentFormValues> {
    const schemaFields: {
        paymentProviderRadio: StringSchema;
    } = {
        paymentProviderRadio: string().required(),
    };

    const schemaFieldsWithTerms = object(schemaFields)
        .concat(getTermsConditionsValidationSchema({ isTermsConditionsRequired, language }))
        .concat(getFormFieldsValidationSchema({
            translate: B3Checkout.extrasFiles.getTranslateAddressError(language),
            formFields: B3Checkout.extrasFiles.getB3OrderExtras(),
        }))

    return additionalValidation ?
        schemaFieldsWithTerms.concat(additionalValidation as any) :
        schemaFieldsWithTerms;
}
